<wsb-modal
  disabledFooter="true"
  class="custom-modal-width"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  title="{{ 'send_sms_pages_insert_modal' | translate }}"
  primaryButtonText="common_send"
>
  <div body>
    <div class="form-group" style="display: flex; align-items: center;">
      <label for="subaccount" class="col-sm-3" translate>send_sms_pages_modal_choose</label>
      <ng-select
        style="width: 240px; margin-right: 24px;"
        bindValue="idPage"
        bindLabel="description"
        [items]="pageList"
        [clearable]="false"
        [formControl]="selectedPage"
        (change)="onSelectionChange($event)"
        class="form-control"
        (scrollToEnd)="onScrollToEnd()"
      >
      </ng-select>
    </div>

    <div class="d-flex" style="flex-direction: column;">
      <div class="landing-container">
        <div
          class="parent"
          #elemt
          (mousedown)="startDragging($event, false, elemt)"
          (mouseup)="stopDragging($event, false)"
          (mouseleave)="stopDragging($event, false)"
          (mousemove)="moveEvent($event, elemt)"
        >
          <div class="child">
            <div class="preview-fixes" [innerHTML]="page?.previewHtml"></div>
          </div>
        </div>
        <!-- <img src="\assets\images\mask_smartphone.png" /> -->
      </div>

      <div footer class="modal-footer" style="display: flex; justify-content: space-between;">
        <wsb-atlas-button
          class="send-sms-button1"
          variant="primary"
          label="send_sms_pages_use"
          (btnClick)="insertCustomLink()"
        ></wsb-atlas-button>
        <wsb-atlas-button
          class="send-sms-button1"
          variant="primary"
          label="send_sms_pages_use_short"
          (btnClick)="insertShortLink()"
        ></wsb-atlas-button>
      </div>
    </div>
  </div>
</wsb-modal>
